import React from "react";
import Modal from "../../components/Modal/Modal";
import Button from "../../components/Button/Button";
import "./ValidationErrorsModal.css";

// Each error: { row?, admissionNo?, studentName?, column?, value?, problem }
// Columns that are empty for every error are not shown.
const COLUMNS = [
  { key: "row", label: "Excel Row" },
  { key: "admissionNo", label: "Admission No" },
  { key: "studentName", label: "Student" },
  { key: "column", label: "Field" },
  { key: "value", label: "Value" },
];

const hasText = (value) =>
  value !== undefined && value !== null && String(value) !== "" && value !== "-";

const ValidationErrorsModal = ({ isOpen, onClose, title, message, errors = [] }) => {
  const visibleColumns = COLUMNS.filter(({ key }) =>
    errors.some((error) => hasText(error[key])),
  );
  const studentCount = new Set(
    errors
      .map((error) => error.admissionNo || error.studentName)
      .filter(hasText),
  ).size;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={errors.length > 0 ? "xl" : "md"}
      footer={
        <Button type="button" variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="validation-errors-summary">
        {errors.length > 0 && (
          <div className="validation-errors-count">
            Found <strong>{errors.length}</strong> problem
            {errors.length === 1 ? "" : "s"}
            {studentCount > 0 && (
              <>
                {" "}for <strong>{studentCount}</strong> student
                {studentCount === 1 ? "" : "s"}
              </>
            )}
            .
          </div>
        )}
        {message && <div>{message}</div>}
      </div>
      {errors.length > 0 && (
        <div className="validation-errors-table-wrap">
          <table className="validation-errors-table">
            <thead>
              <tr>
                <th>#</th>
                {visibleColumns.map(({ key, label }) => (
                  <th key={key}>{label}</th>
                ))}
                <th>Problem</th>
              </tr>
            </thead>
            <tbody>
              {errors.map((error, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  {visibleColumns.map(({ key }) => (
                    <td
                      key={key}
                      className={key === "value" ? "validation-errors-value" : undefined}
                    >
                      {key === "value" && !hasText(error.value) ? (
                        <em>(empty)</em>
                      ) : (
                        error[key]
                      )}
                    </td>
                  ))}
                  <td className="validation-errors-problem">{error.problem}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};

export default ValidationErrorsModal;
